/**
 * Convierte un importe en moneda de búsqueda a EUR.
 * `eurExchange` es el ratio (unidades de la moneda por 1 EUR), p. ej. USD 1.12, GBP 0.85, COP 3700.
 */
export function toEurAmount(amount: number, eurExchange: number | null | undefined): number {
  const value = Number(amount)
  const rate = Number(eurExchange)
  if (!Number.isFinite(value)) return 0
  if (!Number.isFinite(rate) || rate <= 0) return value
  return value / rate
}

/** Redondeo a 2 decimales para analytics / SalesManago. */
export function toEurAmountRounded(amount: number, eurExchange: number | null | undefined): number {
  return Math.round(toEurAmount(amount, eurExchange) * 100) / 100
}

export function parseEurExchange(value: string | number | null | undefined): number | null {
  const rate = Number(value)
  if (!Number.isFinite(rate) || rate <= 0) return null
  return rate
}
